import {makeEl} from "../../common/Utils";
import DataStore from "../DataStore";
import {infoType} from "../../interface/IFooter";

export default class infoCS{
    private ds : DataStore

    constructor(_wrapper: HTMLElement, _csInfoType: infoType) {
        this.ds = DataStore.instance;
        const infoCSString = this.ds.l10n.infoCS[_csInfoType];

        if(infoCSString){
            this.templ(_wrapper, infoCSString);
        }
    }

    templ(_parent: HTMLElement, _data: string){
        makeEl('address', _parent, {class: 'footer-info-address'}).innerHTML=
            `${this.ds.l10n.infoCS.infoAddress} <a href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1448504244" target="_blank"><strong>${this.ds.l10n.infoCS.businessInformation}</strong></a>`
        makeEl('div', _parent, {class: 'footer-info-cs'}).innerHTML=
            `${_data} <span class="footer-info-email">${this.ds.l10n.infoCS.infoEmail} <a href="mailto:credit@ncsoft.com" class="email">credit@ncsoft.com</a></span>`
    }
}